import React from 'react';
import { EditorState } from 'draft-js';
import { convertToHTML as draftConvertToHtml } from 'draft-convert';

import { LINK_ENTITY_NAME } from './constants';

const convertToHTML = (editorState: EditorState) =>
  draftConvertToHtml({
    blockToHTML: {
      unstyled: {
        start: '<p>',
        end: '</p>',
        empty: '<p>&nbsp;</p>',
      },
    },
    entityToHTML: (entity: any, originalText: any) => {
      if (entity.type === LINK_ENTITY_NAME) {
        return <a href={entity.data.url}>{originalText}</a>;
      }
      return originalText;
    },
  })(editorState.getCurrentContent());

export default convertToHTML;
